<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Facilitador"
            description="Gerenciar oficinas, treinamentos e outras atividades coletivas"
            url="/oficinas-treinamentos"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-2311"
            pageIdentifier="oficinas-treinamentos-facilitador"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw
                  ?.oficinas_treinamentos_facilitador_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw
                ?.oficinas_treinamentos_facilitador_ajuda || 0
            "
            keyAjudaModalInformacao="oficinas_treinamentos_facilitador_ajuda"
          />
        </div>
      </div>

      <!-- Tabela de fichas -->
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="card">
            <div
              class="card-header bg-light d-flex justify-content-between align-items-center"
            >
              <h5 class="mb-0">Fichas de Atividade Coletiva</h5>
              <button class="btn btn-primary" @click="criarNovaFicha">
                <i class="icofont-plus"></i> Criar Atividade Coletiva
              </button>
            </div>
            <div class="card-body">
              <div v-if="loading" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Carregando...</span>
                </div>
                <p class="mt-2">Carregando fichas...</p>
              </div>

              <div v-else-if="fichas.length === 0" class="text-center py-5">
                <i
                  class="icofont-file-alt"
                  style="font-size: 48px; color: #ccc"
                ></i>
                <p class="mt-3 text-muted">Nenhuma ficha cadastrada ainda.</p>
              </div>

              <div v-else>
                <div class="box" style="margin-top: 0px">
                  <v-card class="tabela">
                    <v-data-table
                      @pagination="getPagination"
                      :page="currentPage"
                      :footer-props="{
                        itemsPerPageText: '',
                        'items-per-page-options': [10],
                        'disable-items-per-page': true,
                      }"
                      :loading="loading"
                      loading-text="Carregando, Por favor espere"
                      :headers="headers"
                      :items="fichasFiltradasOrdenadas"
                      item-key="id"
                      class="elevation-1"
                    >
                      <template v-slot:[`footer.page-text`]="items">
                        <span class="paginacao">
                          {{ items.pageStart }} - {{ items.pageStop }} de
                          {{ items.itemsLength }}
                          {{ items.itemsLength === 1 ? 'ficha' : 'fichas' }}
                        </span>
                      </template>

                      <template v-slot:item.data_atividade="{ item }">
                        {{ formatarData(obterTimestampAtividade(item)) }}
                      </template>

                      <template v-slot:item.tipo_atividade="{ item }">
                        {{
                          item.subtitulo ||
                          getTipoAtividadeDescricao(
                            item.dados?.atividadeTipo || item.atividadeTipo
                          )
                        }}
                      </template>

                      <template v-slot:item.numero_participantes="{ item }">
                        {{ obterNumeroParticipantes(item) }}
                      </template>

                      <template v-slot:item.responsavel="{ item }">
                        {{ getResponsavelNome(item) }}
                      </template>

                      <template v-slot:item.status="{ item }">
                        <span :class="getStatusBadgeClass(item)">
                          {{ getStatusTexto(item) }}
                        </span>
                      </template>

                      <template v-slot:item.acoes="{ item }">
                        <div
                          class="dropdown"
                          :class="{
                            show:
                              dropdownAberto === item.id ||
                              dropdownAberto === item.uuidFicha ||
                              dropdownAberto === item.nu_uuid_ficha,
                          }"
                          :data-id="
                            item.id || item.uuidFicha || item.nu_uuid_ficha
                          "
                        >
                          <button
                            class="btn btn-sm btn-actions"
                            type="button"
                            @click.stop="
                              toggleDropdown(
                                item.id || item.uuidFicha || item.nu_uuid_ficha
                              )
                            "
                            title="Mais opções"
                          >
                            <i class="mdi mdi-dots-vertical"></i>
                          </button>
                          <div
                            class="dropdown-menu dropdown-menu-right"
                            :class="{
                              show:
                                dropdownAberto === item.id ||
                                dropdownAberto === item.uuidFicha ||
                                dropdownAberto === item.nu_uuid_ficha,
                            }"
                            :style="{
                              display:
                                dropdownAberto === item.id ||
                                dropdownAberto === item.uuidFicha ||
                                dropdownAberto === item.nu_uuid_ficha
                                  ? 'block'
                                  : 'none',
                            }"
                            @click.stop
                          >
                            <template v-if="item.st_ficha_finalizada === 1">
                              <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="
                                  visualizarFicha(item)
                                  fecharDropdown()
                                "
                              >
                                <i class="mdi mdi-eye mr-2"></i>
                                Visualizar
                              </a>
                            </template>
                            <template v-else>
                              <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="
                                  editarFicha(item)
                                  fecharDropdown()
                                "
                              >
                                <i class="mdi mdi-pencil mr-2"></i>
                                Editar
                              </a>
                              <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="
                                  finalizarFicha(item)
                                  fecharDropdown()
                                "
                              >
                                <i class="mdi mdi-check-circle mr-2"></i>
                                Finalizar
                              </a>
                              <a
                                class="dropdown-item text-danger"
                                href="#"
                                @click.prevent="
                                  excluirFicha(item)
                                  fecharDropdown()
                                "
                              >
                                <i class="mdi mdi-delete mr-2"></i>
                                Excluir
                              </a>
                            </template>
                          </div>
                        </div>
                      </template>

                      <template v-slot:no-data>
                        <div class="alert alert-info mb-0">
                          <b>Nenhuma ficha cadastrada ainda.</b>
                        </div>
                      </template>

                      <template v-slot:no-results>
                        <div class="alert alert-info mb-0">
                          <b
                            >Nenhuma informação encontrada. Tente outro termo de
                            busca.</b
                          >
                        </div>
                      </template>
                    </v-data-table>
                  </v-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmação de Finalização -->
    <div
      v-if="mostrarModalFinalizacao"
      class="modal fade show"
      style="display: block"
      tabindex="-1"
      role="dialog"
      @click.self="cancelarFinalizacao"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
        @click.stop
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirmar Finalização</h5>
            <button
              type="button"
              class="close"
              @click="cancelarFinalizacao"
              :disabled="finalizando"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Tem certeza que deseja finalizar esta ficha de atividade coletiva?
            </p>
            <p class="text-muted mb-0">
              <strong
                >Após finalizada, a ficha não poderá mais ser editada ou
                excluída.</strong
              >
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="cancelarFinalizacao"
              :disabled="finalizando"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="confirmarFinalizacao"
              :disabled="finalizando"
            >
              <span
                v-if="finalizando"
                class="spinner-border spinner-border-sm mr-2"
                role="status"
              ></span>
              {{ finalizando ? 'Finalizando...' : 'Finalizar' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="mostrarModalFinalizacao" class="modal-backdrop fade show"></div>

    <!-- Modal de Confirmação de Exclusão -->
    <div
      v-if="mostrarModalExclusao"
      class="modal fade show"
      style="display: block"
      tabindex="-1"
      role="dialog"
      @click.self="cancelarExclusao"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
        @click.stop
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirmar Exclusão</h5>
            <button
              type="button"
              class="close"
              @click="cancelarExclusao"
              :disabled="excluindo"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Tem certeza que deseja excluir esta ficha de atividade coletiva?
            </p>
            <p class="text-muted mb-0">
              <strong>Esta ação não pode ser desfeita.</strong>
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="cancelarExclusao"
              :disabled="excluindo"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="confirmarExclusao"
              :disabled="excluindo"
            >
              <span
                v-if="excluindo"
                class="spinner-border spinner-border-sm mr-2"
                role="status"
              ></span>
              {{ excluindo ? 'Excluindo...' : 'Excluir' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="mostrarModalExclusao" class="modal-backdrop fade show"></div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { jwtDecode } from 'jwt-decode'

export default {
  name: 'ListagemFichasAtividadeColetiva',
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  data() {
    return {
      loading: false,
      fichas: [],
      dropdownAberto: null,
      mostrarModalExclusao: false,
      fichaParaExcluir: null,
      excluindo: false,
      mostrarModalFinalizacao: false,
      fichaParaFinalizar: null,
      finalizando: false,
      currentPage: 1,
      headers: [
        {
          text: 'Data da atividade',
          align: 'start',
          filterable: true,
          value: 'data_atividade',
        },
        {
          text: 'Tipo de atividade',
          align: 'start',
          filterable: true,
          value: 'tipo_atividade',
        },
        {
          text: 'Nº de participantes',
          align: 'start',
          filterable: false,
          value: 'numero_participantes',
        },
        {
          text: 'Responsável',
          align: 'start',
          filterable: true,
          value: 'responsavel',
        },
        {
          text: 'Status',
          align: 'start',
          filterable: false,
          value: 'status',
        },
        {
          text: 'Ações',
          align: 'center',
          filterable: false,
          value: 'acoes',
          sortable: false,
        },
      ],
      opcoesTipoAtividade: [
        { id: '01', descricao: 'Reunião de equipe' },
        { id: '02', descricao: 'Reunião com outras equipes de saúde' },
        {
          id: '03',
          descricao:
            'Reunião intersetorial / Conselho local de saúde / Controle social',
        },
        { id: '04', descricao: 'Educação em saúde' },
        { id: '05', descricao: 'Atendimento em Grupo' },
        { id: '06', descricao: 'Avaliação / Procedimento coletivo' },
        { id: '07', descricao: 'Mobilização social' },
      ],
      opcoesTurno: [
        { id: 1, descricao: 'Manhã' },
        { id: 2, descricao: 'Tarde' },
        { id: 3, descricao: 'Noite' },
      ],
    }
  },
  created() {
    this.carregarFichas()
  },
  mounted() {
    // Fecha o dropdown ao clicar fora
    document.addEventListener('click', this.fecharDropdownAoClicarFora)
  },
  beforeDestroy() {
    // Remove o listener ao destruir o componente
    document.removeEventListener('click', this.fecharDropdownAoClicarFora)
  },
  computed: {
    fichasFiltradasOrdenadas() {
      let lista = Array.isArray(this.fichas) ? [...this.fichas] : []

      lista.sort((a, b) => {
        const dataA = this.obterTimestampAtividade(a) || 0
        const dataB = this.obterTimestampAtividade(b) || 0
        return dataB - dataA
      })

      return lista
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },
    async carregarFichas() {
      this.loading = true
      try {
        const ibge = this.$store.state.cod_ibge || ''
        const endpoint = `/app/oficinas-treinamentos/${ibge}/oficinas`

        const response = await this.$api.get(endpoint)

        if (response && response.data) {
          const dados = response.data.data || response.data
          this.fichas = Array.isArray(dados)
            ? dados.map((item) => this.mapearFichaDaAPI(item))
            : []
        } else {
          this.fichas = []
        }
      } catch (error) {
        if (error.response && error.response.status === 405) {
          this.fichas = []
          this.$toast.warning('Endpoint ainda não está disponível', 'Aviso', {
            position: 'topRight',
            timeout: 3000,
          })
        } else {
          this.fichas = []
          this.$toast.error('Erro ao carregar fichas da API', 'Erro', {
            position: 'topRight',
            timeout: 3000,
          })
        }
      } finally {
        this.loading = false
      }
    },
    mapearFichaDaAPI(item) {
      const dataAtividade = item.data_atividade
        ? new Date(item.data_atividade).getTime()
        : null

      return {
        id: item.id || null,
        uuidFicha: item.id || null,
        nu_uuid_ficha: item.id || null,
        dados: {
          atividadeTipo: item.tipo_atividade || null,
          numParticipantes: item.numero_participantes || 0,
          numeroParticipantes: item.numero_participantes || 0,
          headerTransport: {
            dataAtendimento: dataAtividade,
            nomeProfissional: item.responsavel || null,
          },
          profissionais: [],
        },
        data_atividade: item.data_atividade || null,
        tipo_atividade: item.tipo_atividade || null,
        subtitulo: item.subtitulo || null,
        responsavelNome: item.responsavel || null,
        status: item.status || null,
        st_ficha_finalizada:
          item.ficha_atividade_coletiva?.st_ficha_finalizada ?? 0,
      }
    },
    criarNovaFicha() {
      this.$router.push('/ficha-atividade-coletiva')
    },
    editarFicha(ficha) {
      const id = ficha.id || ficha.uuidFicha || ficha.nu_uuid_ficha
      this.$router.push({
        path: '/ficha-atividade-coletiva',
        query: { id: id },
      })
    },
    // Abre a ficha em modo somente leitura (atividades finalizadas)
    /**
     * @param {Object} ficha - Ficha da listagem (id / uuidFicha / nu_uuid_ficha)
     */
    visualizarFicha(ficha) {
      const id = ficha.id || ficha.uuidFicha || ficha.nu_uuid_ficha
      this.$router.push({
        path: '/ficha-atividade-coletiva',
        query: { id: id, visualizar: '1' },
      })
    },
    toggleDropdown(fichaId) {
      if (this.dropdownAberto === fichaId) {
        this.dropdownAberto = null
      } else {
        this.dropdownAberto = fichaId
        // Aguarda o próximo tick para calcular a posição do dropdown
        this.$nextTick(() => {
          this.ajustarPosicaoDropdown(fichaId)
        })
      }
    },
    ajustarPosicaoDropdown(fichaId) {
      const dropdown = this.$el.querySelector(`.dropdown[data-id="${fichaId}"]`)
      if (!dropdown) {
        return
      }

      const button = dropdown.querySelector('button')
      const menu = dropdown.querySelector('.dropdown-menu')

      if (!button || !menu) {
        return
      }

      const rect = button.getBoundingClientRect()

      menu.style.position = 'fixed'
      menu.style.top = `${rect.bottom + 2}px`
      menu.style.right = `${window.innerWidth - rect.right}px`
      menu.style.left = 'auto'
      menu.style.zIndex = '9999'
      menu.style.display = 'block'
      menu.style.visibility = 'visible'
      menu.style.opacity = '1'
    },
    fecharDropdown() {
      this.dropdownAberto = null
    },
    fecharDropdownAoClicarFora(event) {
      // Fecha o dropdown se o clique foi fora do dropdown
      if (this.dropdownAberto !== null) {
        const dropdownElement = event.target.closest('.dropdown')
        if (!dropdownElement) {
          this.fecharDropdown()
        }
      }
    },
    finalizarFicha(ficha) {
      this.fichaParaFinalizar = ficha
      this.mostrarModalFinalizacao = true
      this.fecharDropdown()
    },
    cancelarFinalizacao() {
      if (this.finalizando) return
      this.mostrarModalFinalizacao = false
      this.fichaParaFinalizar = null
    },
    async confirmarFinalizacao() {
      if (!this.fichaParaFinalizar) return

      this.finalizando = true
      try {
        const ibge = this.$store.state.cod_ibge || ''
        const nu_uuid_ficha =
          this.fichaParaFinalizar.id ||
          this.fichaParaFinalizar.uuidFicha ||
          this.fichaParaFinalizar.nu_uuid_ficha

        if (!nu_uuid_ficha) {
          throw new Error('ID da ficha não encontrado')
        }

        const endpoint = `/app/oficinas-treinamentos/${ibge}/fichas/${nu_uuid_ficha}/status`
        const payload = {
          st_ficha_finalizada: 1,
        }

        const response = await this.$api.post(endpoint, payload)

        if (response.data && response.data.error === true) {
          const mensagemErro =
            response.data.message || 'Erro ao finalizar a ficha.'
          this.$toast.error(mensagemErro, 'Erro', {
            position: 'topRight',
            timeout: 5000,
          })
          return
        }

        // Atualiza o status da ficha na lista local
        const uuid =
          this.fichaParaFinalizar.uuidFicha ||
          this.fichaParaFinalizar.nu_uuid_ficha ||
          this.fichaParaFinalizar.id
        const fichaIndex = this.fichas.findIndex((f) => {
          const fUuid = f.uuidFicha || f.nu_uuid_ficha || f.id
          return fUuid === uuid
        })

        if (fichaIndex !== -1) {
          this.$set(this.fichas[fichaIndex], 'st_ficha_finalizada', 1)
        }

        this.$toast.success('Ficha finalizada com sucesso.', 'Sucesso', {
          position: 'topRight',
          timeout: 3000,
        })

        // Fecha o modal
        this.mostrarModalFinalizacao = false
        this.fichaParaFinalizar = null
      } catch (error) {
        let mensagemErro = 'Erro ao finalizar a ficha. Tente novamente.'

        if (error.response) {
          const status = error.response.status
          const data = error.response.data

          if (status === 404) {
            mensagemErro = 'Ficha não encontrada.'
          } else if (status === 403) {
            mensagemErro = 'Você não tem permissão para finalizar esta ficha.'
          } else if (data?.message) {
            mensagemErro = data.message
          } else if (data?.error === true && data?.message) {
            mensagemErro = data.message
          }
        } else if (error.message) {
          // Erro lançado manualmente ou de outra origem
          mensagemErro = error.message
        }

        this.$toast.error(mensagemErro, 'Erro', {
          position: 'topRight',
          timeout: 5000,
        })
      } finally {
        this.finalizando = false
      }
    },
    excluirFicha(ficha) {
      this.fichaParaExcluir = ficha
      this.mostrarModalExclusao = true
      this.fecharDropdown()
    },
    cancelarExclusao() {
      if (this.excluindo) return
      this.mostrarModalExclusao = false
      this.fichaParaExcluir = null
    },
    async confirmarExclusao() {
      if (!this.fichaParaExcluir) return

      this.excluindo = true
      try {
        const ibge = this.$store.state.cod_ibge || ''
        const id =
          this.fichaParaExcluir.id ||
          this.fichaParaExcluir.uuidFicha ||
          this.fichaParaExcluir.nu_uuid_ficha

        if (!id) {
          throw new Error('ID da ficha não encontrado')
        }

        const endpoint = `/app/oficinas-treinamentos/${ibge}/oficina/${id}`

        const response = await this.$api.delete(endpoint)

        if (response.data && response.data.error === true) {
          const mensagemErro =
            response.data.message || 'Não é possível excluir esta ficha.'
          this.$toast.error(mensagemErro, 'Erro', {
            position: 'topRight',
            timeout: 5000,
          })
          return
        }

        const uuid =
          this.fichaParaExcluir.uuidFicha ||
          this.fichaParaExcluir.nu_uuid_ficha ||
          this.fichaParaExcluir.id
        this.fichas = this.fichas.filter((f) => {
          const fUuid = f.uuidFicha || f.nu_uuid_ficha || f.id
          return fUuid !== uuid
        })

        this.$toast.success('Ficha excluída com sucesso.', 'Sucesso', {
          position: 'topRight',
          timeout: 3000,
        })

        // Fecha o modal
        this.mostrarModalExclusao = false
        this.fichaParaExcluir = null
      } catch (error) {
        let mensagemErro = 'Erro ao excluir a ficha. Tente novamente.'

        if (error.response) {
          const status = error.response.status
          const data = error.response.data

          if (status === 404) {
            mensagemErro = 'Ficha não encontrada.'
          } else if (status === 403) {
            mensagemErro = 'Você não tem permissão para excluir esta ficha.'
          } else if (status === 409) {
            // Conflito - não é possível excluir (ex: possui participantes)
            mensagemErro = data?.message || 'Não é possível excluir esta ficha.'
          } else if (data?.message) {
            mensagemErro = data.message
          } else if (data?.error === true && data?.message) {
            mensagemErro = data.message
          }
        } else if (error.message) {
          mensagemErro = error.message
        }

        this.$toast.error(mensagemErro, 'Erro', {
          position: 'topRight',
          timeout: 5000,
        })
      } finally {
        this.excluindo = false
      }
    },
    baixarXML(ficha) {
      try {
        const xml = this.gerarXML(ficha)
        const blob = new Blob([xml], { type: 'application/xml' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url

        const uuid = ficha.uuidFicha || ficha.nu_uuid_ficha || 'ficha'
        const nomeArquivo = `FAC_${uuid}.xml`

        link.download = nomeArquivo
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$toast.success('XML baixado com sucesso!', 'Sucesso', {
          position: 'topRight',
          timeout: 3000,
        })
      } catch (error) {
        this.$toast.error('Erro ao gerar o arquivo XML', 'Erro', {
          position: 'topRight',
          timeout: 3000,
        })
      }
    },
    gerarXML(json) {
      // Função auxiliar para escapar caracteres XML
      const escapeXml = (str) => {
        if (str === null || str === undefined) return ''
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&apos;')
      }

      const formatarValor = (valor) => {
        if (valor === null || valor === undefined) return ''
        if (typeof valor === 'boolean') return valor ? 'true' : 'false'
        return String(valor)
      }

      const criarElementoSimples = (nome, valor, nivel = 0) => {
        const indentacao = '  '.repeat(nivel)
        const valorFormatado = formatarValor(valor)
        if (valorFormatado === '') {
          return `${indentacao}<${nome}></${nome}>\n`
        }
        return `${indentacao}<${nome}>${escapeXml(valorFormatado)}</${nome}>\n`
      }

      const criarElemento = (nome, valor, nivel = 0) => {
        const indentacao = '  '.repeat(nivel)

        if (valor === null || valor === undefined) {
          return `${indentacao}<${nome}></${nome}>\n`
        }

        if (
          Array.isArray(valor) &&
          valor.length > 0 &&
          typeof valor[0] === 'object'
        ) {
          let xml = ''
          valor.forEach((item) => {
            xml += `${indentacao}<${nome}>\n`
            Object.keys(item).forEach((key) => {
              xml += criarElemento(key, item[key], nivel + 1)
            })
            xml += `${indentacao}</${nome}>\n`
          })
          return xml
        }

        if (Array.isArray(valor)) {
          if (valor.length === 0) {
            return `${indentacao}<${nome}></${nome}>\n`
          }
          let xml = ''
          valor.forEach((item) => {
            xml += criarElementoSimples(nome, item, nivel)
          })
          return xml
        }

        if (typeof valor === 'object' && valor !== null) {
          let xml = `${indentacao}<${nome}>\n`
          Object.keys(valor).forEach((key) => {
            xml += criarElemento(key, valor[key], nivel + 1)
          })
          xml += `${indentacao}</${nome}>\n`
          return xml
        }

        return criarElementoSimples(nome, valor, nivel)
      }

      const jsonFormatado = json.dados
        ? json
        : {
            nu_uuid_ficha: json.uuidFicha || json.nu_uuid_ficha,
            tp_ficha: json.tp_ficha || '3',
            dados: json.dados || json,
          }

      let xml = '<?xml version="1.0" encoding="UTF-8"?>\n'
      xml += '<fichaAtividadeColetiva>\n'

      xml += criarElementoSimples(
        'nu_uuid_ficha',
        jsonFormatado.nu_uuid_ficha,
        1
      )
      xml += criarElementoSimples('tp_ficha', jsonFormatado.tp_ficha, 1)

      if (jsonFormatado.dados) {
        xml += '  <dados>\n'
        Object.keys(jsonFormatado.dados).forEach((key) => {
          xml += criarElemento(key, jsonFormatado.dados[key], 2)
        })
        xml += '  </dados>\n'
      }

      xml += '</fichaAtividadeColetiva>'
      return xml
    },
    obterTimestampAtividade(ficha) {
      const ts =
        ficha.dados?.headerTransport?.dataAtendimento ||
        ficha.dataAtendimento ||
        (ficha.data_atividade
          ? new Date(ficha.data_atividade).getTime()
          : null) ||
        (ficha.inicio ? new Date(ficha.inicio).getTime() : null) ||
        null
      return ts ? Number(ts) : null
    },
    obterNumeroParticipantes(ficha) {
      const dados = ficha.dados || ficha
      const numParticipantes =
        dados.numParticipantes ||
        dados.numeroParticipantes ||
        dados.num_participantes ||
        ficha.num_participantes ||
        ficha.qtd_participantes ||
        (ficha.participantes && Array.isArray(ficha.participantes)
          ? ficha.participantes.length
          : null) ||
        0
      return numParticipantes
    },
    getTipoAtividadeDescricao(id) {
      if (!id) return '-'
      const tipo = this.opcoesTipoAtividade.find(
        (t) => t.id === String(id).padStart(2, '0')
      )
      return tipo ? tipo.descricao : `Tipo ${id}`
    },
    getTurnoDescricao(id) {
      if (!id) return '-'
      const turno = this.opcoesTurno.find((t) => t.id === id)
      return turno ? turno.descricao : `Turno ${id}`
    },
    getResponsavelNome(ficha) {
      if (ficha.responsavelNome) return ficha.responsavelNome
      if (ficha.nome_facilitador) return ficha.nome_facilitador
      if (ficha.dados?.headerTransport?.nomeProfissional) {
        return ficha.dados.headerTransport.nomeProfissional
      }

      const profissionais =
        ficha.dados?.profissionais || ficha.profissionais || []
      if (Array.isArray(profissionais) && profissionais.length > 0) {
        if (profissionais[0].nome) return profissionais[0].nome
        if (profissionais[0].no_profissional)
          return profissionais[0].no_profissional
      }

      return this.$store?.state?.username || '—'
    },
    getStatusTexto(ficha) {
      const status = ficha.st_ficha_finalizada ?? 0
      return status === 1 ? 'Finalizada' : 'Em andamento'
    },
    getStatusBadgeClass(ficha) {
      const status = ficha.st_ficha_finalizada ?? 0
      return status === 1 ? 'badge badge-primary' : 'badge badge-secondary'
    },
    formatarData(timestamp) {
      if (!timestamp) return '-'
      const data = new Date(timestamp)
      if (isNaN(data.getTime())) return '-'
      return data.toLocaleDateString('pt-BR')
    },
    getCnsProfissionalLogado() {
      try {
        if (this.$store?.state?.accessToken) {
          const decoded = jwtDecode(this.$store.state.accessToken)
          if (decoded?.nu_cns) return decoded.nu_cns
        }
        return this.$store?.state?.nu_cns || null
      } catch (e) {
        return null
      }
    },
  },
}
</script>

<style scoped>
.card {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.card-header {
  padding: 15px 20px;
  border-bottom: 1px solid #e0e0e0;
}

.card-body {
  padding: 20px;
}

/* Switch customizado (estilo iOS parecido com o exemplo) */
.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 18px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.2s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 14px;
  width: 14px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.2s;
}

input:checked + .slider {
  background-color: #00a0df;
}

input:checked + .slider:before {
  transform: translateX(16px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.table {
  margin-bottom: 0;
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
  font-size: 0.9rem;
}

.table td {
  vertical-align: middle;
  font-size: 0.9rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.btn-actions {
  background: transparent;
  border: none;
  color: #6c757d;
  padding: 4px 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-actions:hover {
  background: #f8f9fa;
  color: #495057;
  border-radius: 4px;
}

.btn-actions:focus {
  box-shadow: none;
  outline: none;
}

.btn-actions i {
  font-size: 1.2rem;
}

.dropdown.show .dropdown-menu {
  display: block !important;
}

/* Ajustes para dropdown dentro da tabela */
.table-responsive .dropdown {
  position: relative;
}

.table-responsive .dropdown-menu {
  position: fixed !important;
  z-index: 9999 !important;
  margin-top: 0.125rem;
  min-width: 200px;
  display: none !important;
}

.table-responsive .dropdown.show .dropdown-menu,
.table-responsive .dropdown-menu[style*='display: block'] {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Garante que a tabela não corte o dropdown */
.table-responsive {
  overflow: visible !important;
}

.table {
  overflow: visible !important;
}

.table tbody {
  overflow: visible !important;
}

.table tbody tr {
  overflow: visible !important;
}

.table tbody td {
  overflow: visible !important;
  position: relative;
}

.badge {
  display: inline-block;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.badge-primary {
  color: #fff;
  background-color: rgb(15, 175, 215);
}

.badge-success {
  color: #fff;
  background-color: #28a745;
}

.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.box {
  margin-top: 0px;
}

.tabela {
  padding: 0px;
}

.input-bottom {
  margin-bottom: 0;
}

.paginacao {
  font-size: 0.875rem;
  color: #6c757d;
}

/* Estilos para v-data-table */
.v-data-table {
  overflow: visible !important;
}

.v-data-table__wrapper {
  overflow: visible !important;
}

.v-data-table table {
  overflow: visible !important;
}

.v-data-table tbody {
  overflow: visible !important;
}

.v-data-table tbody tr {
  overflow: visible !important;
}

.v-data-table tbody td {
  overflow: visible !important;
  position: relative;
}

.v-data-table .dropdown {
  position: relative;
}

.v-data-table .dropdown-menu {
  position: fixed !important;
  z-index: 9999 !important;
  margin-top: 0.125rem;
  min-width: 200px;
  display: none !important;
}

.v-data-table .dropdown.show .dropdown-menu,
.v-data-table .dropdown-menu[style*='display: block'] {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Modal Styles */
.modal {
  z-index: 1050;
}

.modal-backdrop {
  z-index: 1040;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-dialog {
  margin: 1.75rem auto;
}

.modal-content {
  border: none;
  border-radius: 0.3rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.modal-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
}

.modal-footer .btn {
  margin-left: 0;
}

.close {
  padding: 0;
  background-color: transparent;
  border: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  opacity: 0.5;
  cursor: pointer;
}

.close:hover {
  opacity: 0.75;
}

.close:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
